<template>
	<div
		class="fixed bottom-0 right-0 ma-5 z-9 rounded-4 pa-2 text-white text-label-l d-flex align-center gap-1 pointer-events-none"
		:class="environment === 'staging' ? 'bg-secondary-700' : 'bg-social-700'"
		v-if="!isXS && environment !== 'production'"
	>
		<NewIcon
			:icon="environment === 'staging' ? 'warning' : 'paw-print'"
			skip-import
			radius="18px"
		/>
		<p>{{ environment.toUpperCase() }}</p>
	</div>
</template>

<script setup lang="ts">
	import NewIcon from './NewIcon.vue'

	interface Props {
		environment: 'development' | 'staging' | 'production'
		isXS: boolean
	}
	defineProps<Props>()
</script>
